import { Box, Tooltip, Typography } from "@mui/material"
import { REGIME_SCHEDULE_TOTAL_EXPLANATION } from "./regime-schedule-counts-constants.mjs"

// Number first and in bold ("1,005 live schedules"), so the count is the first thing people read.
// In the regime list the caption sits inside a clickable row or card, so it must not be its own focus stop there.
export function RegimeScheduleTotalCaption({ total, focusable = true }) {
    const noun = total.count === 1 ? "schedule" : "schedules"
    return (
        <Tooltip describeChild title={REGIME_SCHEDULE_TOTAL_EXPLANATION}>
            <Typography
                component="span"
                variant="body2"
                color="text.primary"
                tabIndex={focusable ? 0 : undefined}
                // The regime card capitalises every word ("No Facilities"); the count should read "2 draft schedules".
                sx={{ whiteSpace: "nowrap", textTransform: "none" }}
                data-cy="regime-schedule-total"
            >
                <Box component="strong" sx={{ fontWeight: "fontWeightBold" }} data-cy="regime-schedule-total-count">
                    {total.count.toLocaleString("en-GB")}
                </Box>{" "}
                {total.label.toLowerCase()} {noun}
            </Typography>
        </Tooltip>
    )
}
